// extracted by mini-css-extract-plugin
module.exports = {"taskProgress":"style-module_taskProgress__2mx3Md41YpeKbIfyNCq836","disabled":"style-module_disabled__2-I2P28TktHrSKOeWBXbYY"};